(function () {
  const root = document.querySelector('[data-kobu-quiz]');
  if (!root) return;

  const form = root.querySelector('form');
  const steps = Array.from(root.querySelectorAll('[data-quiz-step]'));
  const progress = root.querySelector('[data-quiz-progress]');
  const previous = root.querySelector('[data-quiz-previous]');
  const next = root.querySelector('[data-quiz-next]');
  const submit = root.querySelector('[data-quiz-submit]');
  const error = root.querySelector('[data-quiz-error]');
  const email = root.querySelector('[data-quiz-email]');
  const answersInput = root.querySelector('[data-quiz-answers]');
  const code = root.querySelector('[data-quiz-code]');
  const copyCode = root.querySelector('[data-quiz-copy]');
  const copyCodeLabel = root.querySelector('[data-quiz-copy-label]');
  let current = 0;

  const setError = (message) => { if (error) error.textContent = message || ''; };

  copyCode?.addEventListener('click', async () => {
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code.value);
    } catch (clipboardError) {
      code.select();
      document.execCommand('copy');
      code.setSelectionRange(0, 0);
    }

    copyCode.setAttribute('aria-label', 'Copied');
    copyCode.setAttribute('title', 'Copied');
    if (copyCodeLabel) copyCodeLabel.textContent = 'Copied';
    window.setTimeout(() => {
      copyCode.setAttribute('aria-label', 'Copy discount code');
      copyCode.setAttribute('title', 'Copy discount code');
      if (copyCodeLabel) copyCodeLabel.textContent = 'Copy discount code';
    }, 1800);
  });

  function render() {
    steps.forEach((step, index) => { step.hidden = index !== current; });
    progress.textContent = `Question ${current + 1} of ${steps.length}`;
    previous.disabled = current === 0;
    next.hidden = current === steps.length - 1;
    submit.hidden = current !== steps.length - 1;
    setError('');
  }

  function currentAnswerIsValid() {
    const step = steps[current];
    if (step.dataset.quizType === 'choice') {
      if (step.querySelector('.is-selected')) return true;
      setError('Please choose an answer to continue.');
      return false;
    }
    if (!email.value.trim() || !email.checkValidity()) {
      setError('Please enter a valid email address to submit your answers.');
      email.focus();
      return false;
    }
    return true;
  }

  function getFormattedAnswers() {
    return steps
      .filter((step) => step.dataset.quizType === 'choice')
      .map((step, index) => {
        const question = step.querySelector('.kobu-quiz__question')?.textContent.trim() || `Question ${index + 1}`;
        const answer = step.querySelector('.is-selected')?.dataset.value || '';
        return `${index + 1}. ${question}\nAnswer: ${answer}`;
      })
      .join('\n\n');
  }

  root.querySelectorAll('[data-quiz-choice]').forEach((choice) => {
    choice.addEventListener('click', () => {
      const group = choice.closest('[data-quiz-step]');
      group.querySelectorAll('[data-quiz-choice]').forEach((item) => {
        item.classList.toggle('is-selected', item === choice);
        item.setAttribute('aria-pressed', String(item === choice));
      });
      setError('');
    });
  });

  previous.addEventListener('click', () => { if (current > 0) { current -= 1; render(); } });
  next.addEventListener('click', () => {
    if (!currentAnswerIsValid()) return;
    current += 1;
    render();
  });

  form.addEventListener('submit', (event) => {
    if (!currentAnswerIsValid()) {
      event.preventDefault();
      return;
    }
    answersInput.value = getFormattedAnswers();
    submit.disabled = true;
    submit.textContent = 'Sending…';
  });

  render();
})();
